import React from 'react';
import Navbar from '../../navbar/Navbar';

type MainLayoutType = {
  children: React.ReactNode;
};

const MainLayout = ({ children }: MainLayoutType) => (
  <div className=" text-mainWhite flex flex-col gap-4 max-w-5xl mx-auto">
    <Navbar />
    <div className="px-4 py-6 xl:px-0">
      <main className="flex flex-col  gap-4 relative  divide-y divide-slate-800 divide-solid">
        {children}
      </main>
    </div>
  </div>
);

export default MainLayout;
